export enum DateTimeFormats {
  ISO_DATE = 'YYYY-MM-DD',
  DISPLAY_DATE = 'DD/MM/YYYY',
  ISO_TIME = 'HH:mm',
  SHORT_DATE = 'dd D MMM',
  LONG_FULL_DATE = 'dddd D MMMM yyyy',
}
